export default {
  OpenModuleTitle: "Loan Enquiry",
  LOAN_ENQUIRY_SUCCESS: 0,
  LOAN_ENQUIRY_NOT_ELIGIBLE_RESPONSE: 1,
  LOAN_ENQUIRY_NOT_FOUND: 404,
  LOAN_ENQUIRY_UNAUTHORIZED: 401,
  inOutType_Income: "I",
  inOutType_Outgoing: "O",

  // Drawdown Method - Electronic Funds Transfer
  EFT: "EFT", 
  
  // Source of Repayment
  BenefitsToPayment: "BP",
  StandingOrder: "SO",
  PayrollMandate: "PM",

  PBCodes: {
    412: 412    
  }
};